"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChunkPosition = exports.PartialTransferrer = void 0;
var progress_1 = require("./progress");
var promise_1 = require("../utils/promise");
var object_1 = require("./object");
var cancel_1 = require("./cancel");
var id = 0;
var PartialTransferrer = /** @class */ (function (_super) {
    __extends(PartialTransferrer, _super);
    function PartialTransferrer(transferChunkFunc, config, name) {
        var _this = _super.call(this, name || "Transferrer") || this;
        _this.transferChunkFunc = transferChunkFunc;
        config = config || {};
        _this.chunkSize = config.chunkSize || 4 * 1024 * 1024;
        _this.maxAttempts = config.maxAttempts || 3;
        _this.retryDelay = config.retryDelay || 0;
        return _this;
    }
    PartialTransferrer.prototype.transfer = function (source, sink, sourceOffset, sinkOffset, count, token, p) {
        var _this = this;
        var state = {
            progress: p || new progress_1.Progress(this.toString()),
            token: token || cancel_1.CancellationToken.empty(),
            crashed: false,
            activeRetries: {},
        };
        var transferId = "transfer" + id++;
        this.log.debug(transferId, {
            source: source,
            sink: sink,
            sourceOffset: sourceOffset,
            sinkOffset: sinkOffset,
            count: count,
        });
        var chunks = enumerateChunks(0, count, this.chunkSize);
        return sink
            .wait()
            .then(function () {
            return _this.writeNextChunk(source, sink, sourceOffset, sinkOffset, chunks, state);
        })
            .then(function () {
            _this.log.debug("finished", { transferId: transferId });
            state.progress.complete();
            return sink;
        }, function (error) {
            if (!(0, cancel_1.isCancellationError)(error))
                _this.log.error("Transfer from source to sourceOffset failed", error, { transferId: transferId, source: source, sourceOffset: sourceOffset });
            return Promise.reject(error);
        });
    };
    PartialTransferrer.prototype.writeNextChunk = function (source, sink, sourceOffset, sinkOffset, chunks, state) {
        var _this = this;
        state.token.throwIfCancelled();
        if (!chunks.moveNext() || state.crashed) {
            return (0, promise_1.promiseResolve)();
        }
        var percentsPerChunk = 100 / chunks.count;
        return source.wait().then(function () {
            var chunkPosition = chunks.current();
            state.token.throwIfCancelled();
            if (state.crashed)
                return (0, promise_1.promiseResolve)();
            var sliceSourceOffset = chunkPosition.offset + sourceOffset;
            var sliceSinkOffset = chunkPosition.offset + sinkOffset;
            var currentTransfer = _this.transferSlice(source, sink, sliceSourceOffset, sliceSinkOffset, chunkPosition.size, state);
            var intervalMs = _this.retryDelay || 100;
            var nextTransfer = sink
                .wait()
                .then(function () {
                var activeRetries = Object.keys(state.activeRetries);
                return (0, promise_1.wait)(function () { return activeRetries.length === 0 || state.crashed; }, { intervalMs: intervalMs }, state.token);
            })
                .then(function () {
                return _this.writeNextChunk(source, sink, sourceOffset, sinkOffset, chunks, state);
            });
            return currentTransfer.then(function () {
                state.progress.add(percentsPerChunk);
                return nextTransfer;
            }, function (error) {
                state.crashed = true;
                throw error;
            });
        });
    };
    PartialTransferrer.prototype.transferSlice = function (source, sink, sourceOffset, sinkOffset, count, state, attempt, attemptId) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1, delayPromise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attempt = attempt || 1;
                        attemptId = attemptId || Math.random();
                        state.token.throwIfCancelled();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 6]);
                        return [4 /*yield*/, this.transferChunkFunc(source, sink, sourceOffset, sinkOffset, count, state.token)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        error_1 = _a.sent();
                        if ((0, cancel_1.isCancellationError)(error_1)) {
                            this.log.warn("Transfer Chunk cancelled via promise rejection");
                            throw error_1;
                        }
                        if (this.maxAttempts <= attempt) {
                            this.log.error("Transfer Chunk FAILED. Max attempts reached", error_1, {
                                source: source,
                                sink: sink,
                                sourceOffset: sourceOffset,
                                sinkOffset: sinkOffset,
                                count: count,
                            });
                            throw error_1;
                        }
                        this.log.warn("Transfer Chunk FAILED. Retry", {
                            attempt: attempt,
                            attemptId: attemptId,
                            source: source,
                            sink: sink,
                            sourceOffset: sourceOffset,
                            sinkOffset: sinkOffset,
                            count: count,
                        });
                        state.activeRetries[attemptId] = true;
                        delayPromise = this.retryDelay
                            ? (0, promise_1.promiseDelay)(this.retryDelay)
                            : (0, promise_1.promiseResolve)();
                        return [4 /*yield*/, delayPromise];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.transferSlice(source, sink, sourceOffset, sinkOffset, count, state, attempt + 1, attemptId)];
                    case 5:
                        _a.sent();
                        delete state.activeRetries[attemptId];
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return PartialTransferrer;
}(object_1.BaseObject));
exports.PartialTransferrer = PartialTransferrer;
function enumerateChunks(offset, size, partSize) {
    var step = offset;
    var currentOffset = 0;
    return {
        current: function () {
            var chunkSize = Math.min(partSize, size - currentOffset);
            return new ChunkPosition(currentOffset, chunkSize);
        },
        moveNext: function () {
            currentOffset += step;
            step = partSize;
            return currentOffset < size;
        },
        count: size / partSize,
    };
}
var ChunkPosition = /** @class */ (function () {
    function ChunkPosition(offset, size) {
        this.offset = offset;
        this.size = size;
    }
    ChunkPosition.prototype.toString = function () {
        return "POS:" + this.offset + "-" + this.size + ";";
    };
    return ChunkPosition;
}());
exports.ChunkPosition = ChunkPosition;
